import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/services/mahurt.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function  Muhart(props2){


    return(
<div>
<Topheader></Topheader>
<Innerbanner title={"Auspicious Days  and Time for any Event (Muhrat)"}></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">

    <div className="bg-light shadow p-3 m-3 flex-fill"><img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid float-start m-3"></img>
   <p> 
   
   Determining auspicious days and times (Shubh Muhurat) for events is a long-standing tradition in Vedic astrology. It is believed that performing important tasks during these times can lead to favorable outcomes. Here's a guide on how you can find those perfect timings:</p>  
<p>
<span className="fw-bolder">Panchang </span> Utilized across Hindu traditions, a Panchang is an elaborate almanac that includes vital details such as the Tithi (lunar day), Nakshatra (constellation), Yoga (auspicious combinations), and Karana (half-day periods). Consulting a Panchang for a specific date reveals the most auspicious timings based on celestial movements</p><p>
<span className="fw-bolder">Tithi:</span>This is the lunar day in the Hindu calendar. Each Tithi is associated with specific attributes and influences which can be favorable or unfavorable for certain activities.</p>
<p>
<span className="fw-bolder">Nakshatra:</span> The position of the moon in various constellations (Nakshatras) impacts different aspects of life. Each Nakshatra has specific characteristics that can influence the suitability of days for particular events.</p><p>
<span className="fw-bolder">Yoga:</span> This refers to the combinations of celestial factors affecting prosperity, health, and success2. Identifying an auspicious Yoga can enhance the positive outcomes of your activities.</p>


<p>Consulting an astrologer for personalized insights can also provide a more tailored approach to finding the best days and times for your specific events.</p>
<p className="text-center"><h6>Need help finding the right time for a specific even</h6><a href='https://api.whatsapp.com/send?phone=919873336259&text='><button className="btn btn-danger">I'm here to assist!</button></a></p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export {Muhart} ;